window.addEventListener("DOMContentLoaded", () => {
    if (document.getElementById('close')) {

        if (document.getElementById('close').classList.contains('pdw-icon-close')) {
            document.getElementById('close').addEventListener('click', () => {
                document.querySelector('.info-content').classList.toggle('d-none');
                document.getElementById('close').classList.toggle('pdw-icon-close');
                document.getElementById('pdw-info-box').classList.toggle('open');
                document.getElementById('pdw-info-box').classList.toggle('closed');
                document.getElementById('close').classList.toggle('pdw-icon-info');
            });
        } else {

        }
        if (document.getElementById('close').classList.contains('pdw-icon-info')) {
            document.getElementById('close').addEventListener('click', () => {
                document.querySelector('.info-content').classList.toggle('d-none');
                document.getElementById('close').classList.toggle('pdw-icon-close');
                document.getElementById('pdw-info-box').classList.toggle('closed');
                document.getElementById('pdw-info-box').classList.toggle('open');
                document.getElementById('close').classList.toggle('pdw-icon-info');
            });
        } else {

        }
    }
});